import { render, staticRenderFns } from "./RemarkEditor.vue?vue&type=template&id=7c598d37&scoped=true"
import script from "./RemarkEditor.vue?vue&type=script&lang=js"
export * from "./RemarkEditor.vue?vue&type=script&lang=js"
import style0 from "./RemarkEditor.vue?vue&type=style&index=0&id=7c598d37&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c598d37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c598d37')) {
      api.createRecord('7c598d37', component.options)
    } else {
      api.reload('7c598d37', component.options)
    }
    module.hot.accept("./RemarkEditor.vue?vue&type=template&id=7c598d37&scoped=true", function () {
      api.rerender('7c598d37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/componentStyle/dialog/RemarkEditor.vue"
export default component.exports